import PropTypes from 'prop-types';
import { Box, ListItem } from '@mui/material';
import PaginatedList from 'src/components/ui/list/paginated-list';
import HeaderCellText from 'src/components/ui/list/header-cell-text';
import ListCellText from 'src/components/ui/list/list-cell-text';

export const ListView = (props) => {
  const {
    dataStore,
    onPageChange = () => {},
    onRowsPerPageChange,
    page = 0,
    rowsPerPage = 0,
    onDetailClicked,
  } = props;
  
  const renderItem = (item, rowstyle, idx) => (
    <ListItem
      divider={true}
      key={idx}
      sx={rowstyle}
      onClick={() => onDetailClicked(item)}
    >
      <ListCellText flex="0 0 35%" color='primary.main' primary={item.courseName} />
      <ListCellText flex="0 0 55%" align='right' primary={item.statusName} />
      <ListCellText flex="0 0 10%" align='right' primary={item.quantity} />
    </ListItem>
  );

  return (
    <Box sx={{ position: 'relative' }}>
      <PaginatedList
        items={dataStore.items}
        loading={dataStore.loading}
        renderItem={renderItem}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
      >
        <HeaderCellText sx={{ width: '35%' }}>Tên khóa</HeaderCellText>
        <HeaderCellText sx={{ width: '55%', textAlign: 'right' }}>Trạng thái</HeaderCellText>
        <HeaderCellText sx={{ width: '10%', textAlign: 'right' }}>SL</HeaderCellText>
      </PaginatedList>
    </Box>
  );
};

ListView.propTypes = {
  dataStore: PropTypes.object,
  onDeselectAll: PropTypes.func,
  onDeselectOne: PropTypes.func,
  onPageChange: PropTypes.func,
  onRowsPerPageChange: PropTypes.func,
  onSelectAll: PropTypes.func,
  onSelectOne: PropTypes.func,
  page: PropTypes.number,
  rowsPerPage: PropTypes.number,
  selected: PropTypes.array,
};
